/** @module                         React */

import { useState, useEffect }     from "react";

/**
 * 
 * @returns products collection item count and hook to update this number
 * 
 */

export const useProductsCount = () => { const

    /** @description user's product collection length */

    collectionLength = JSON.parse ( 
        
        localStorage.getItem ( "productsCollectionCount" ) ) 
        
        || 
        
        JSON.parse ( "12" 
        
    ),

    /** @event useState */

    [ itemsCount, setItemsCount ] = useState ( collectionLength );

    /** 
     * 
     * @description update user's collection length in local storage
     * 
     * @event useEffect 
     * 
     */

    useEffect ( () => {

        localStorage.setItem ( "productsCollectionCount", JSON.stringify ( itemsCount ) );

    }, [ itemsCount, setItemsCount ] );

    /** @returns hook data */

    return { itemsCount, setItemsCount };

};